import React, { Component } from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import FontAwesome from 'react-fontawesome';
import { findDOMNode } from 'slate-react';

import moment from 'moment';
import Actions from '../../store/actions';
import { Delete as DeleteColor } from '../../styling/theme';
import { Delete as DeleteIcon } from '../userDocuments/editDocument/editJournal/toolset/assets/icons';
import {
  CommentPopup,
  Comments,
  DeleteIconWrapper,
  DeleteMessageWrapper,
  User,
  UserName,
  UserProfile,
  UserProfileWrapper,
  Message,
  MessageText,
  SendMessageWrapper,
  MessageWrapper,
  TimeWrapper,
  TextArea,
  Send,
  Buttons,
  ShowComments,
  CommentIndex,
  Arrow,
  MsgBtn,
  CommentNumbers,
  CommentsData,
  Spinner,
  PlaceHolder,
  CancelBtn,
  Overlay,
  ThreadDeleteMsg,
  ThreadButton,
  ThreadDeleteButtons,
} from './shared/commentCardStyles';
import getToken from '../../utility/getToken';
import { RightArrowSVG } from '../drive/driveIcons';
import CommentsController from '../../utility/commentsController';
import AccessTypes from '../../constants/accessTypes';
import SnackBarAlerts from '../common/snackBarAlerts/snackBarAlerts';
import ComponentSections from '../userDocuments/editDocument/editResume/EditSpace/LeftPane/componentSection';
import { FormatTypes } from '../../constants/templateDictionaries';
import { getSectionKey } from '../userDocuments/editDocument/editResume/EditSpace/EditorPane/RenderContent/showResumeSection';
import { CANCEL, COMMENT, PLACE_HOLDER } from './commetData';

class CommentsCard extends Component {
  state = {
    loading: false,
    commentString: '',
    comments: [],
    getCommentLoad: false,
    snackBarMessage: '',
    snackBarType: 'info',
    showSnackBar: false,
    top: 0,
    left: 0,
    right: null,
    deleteThread: false,
    commentData: {},
  };

  popupRef = React.createRef();

  commentsRef = React.createRef();

  textAreaRef = React.createRef();

  prevSelection = '';

  activeElement = null;

  componentDidMount = () => {
    const {
      editorRef: editor,
      comments: { commentsData, activeCommentId },
    } = this.props;
    this.setState({
      comments: commentsData[activeCommentId] || [],
    });
    if (editor && editor.value) this.setTopLeft();
    document.addEventListener('mousedown', this.handleClickOutside);
    if (editor && editor.value) {
      const {
        value: { selection: prevSelectionRef },
      } = editor;
      this.prevSelection = prevSelectionRef;
    }
  };

  setTopLeft = () => {
    const {
      editorRef: {
        value: { focusBlock, document: editorDocument },
      },
      userDocument: { userPreferences },
    } = this.props;
    const title = this.getTitle(userPreferences);
    let addTopPx = 50;
    let addLeftPx = 20;
    if (focusBlock) {
      const { type: focusBlockType } = focusBlock;

      const parent = editorDocument.getParent(focusBlock.key);
      if (
        focusBlockType === 'phone_number' ||
        focusBlockType === 'personal_link'
      ) {
        addTopPx = 20;
        addLeftPx = 0;
      } else if (
        ComponentSections[focusBlockType] === 'Personal Info' ||
        parent.type === 'objective'
      ) {
        addTopPx = 25;
        addLeftPx = 0;
      } else if (title === 'Cover Letter Main') addTopPx += 20;
    }
    try {
      const native = window.getSelection();
      // eslint-disable-next-line react/no-find-dom-node
      const focusDOMNode = findDOMNode(editorDocument);
      const focusRect = focusDOMNode.getBoundingClientRect();
      const range = native.getRangeAt(0);
      const rect = range.getBoundingClientRect();
      const editorContainer = document
        .querySelector('.editor-container')
        .getBoundingClientRect();
      const commentCard =
        this.popupRef.current && this.popupRef.current.getBoundingClientRect();

      const top = rect.y - focusRect.y + addTopPx;
      let left = rect.x - focusRect.x + addLeftPx;
      if (rect.x + left > editorContainer.width) {
        const removePx = left - commentCard.width;
        left = removePx;
      }
      this.setState({
        top,
        left,
      });
      // eslint-disable-next-line no-empty
    } catch (e) {}
  };

  componentDidUpdate = (prevProps) => {
    this.scrollToBottom();
    const {
      comments: { commentsData, activeCommentId: currentId },
    } = this.props;
    const {
      comments: { activeCommentId: previousId },
    } = prevProps;
    if (currentId !== previousId) {
      this.setState({
        comments: commentsData[currentId] || [],
      });
    }
  };

  componentWillUnmount = () => {
    document.removeEventListener('mousedown', this.handleClickOutside);
  };

  handleClickOutside = (e) => {
    if (this.popupRef.current && !this.popupRef.current.contains(e.target)) {
      this.hidePopup();
    }
  };

  scrollToBottom = () => {
    if (this.commentsRef.current)
      this.commentsRef.current.scrollTop =
        this.commentsRef.current.scrollHeight;
  };

  updateState = () => {
    if (this.activeElement && this.activeElement.innerHTML)
      this.activeElement.innerHTML = '';

    const {
      comments: { activeCommentId, commentsData },
    } = this.props;
    this.setState({
      commentString: '',
      comments: commentsData[activeCommentId],
    });
  };

  setLoader = (status) => {
    this.setState({
      loading: status,
    });
  };

  showDocumentDeleted = () => {
    this.setSnackBarState(true, 'error', `Document is deleted!`);
  };

  getTitle = ({ leftPane }) => {
    if (!leftPane) return 'Cover Letter Main';
    const { activeElement } = leftPane;
    return getSectionKey(activeElement);
  };

  addComment = async () => {
    const { commentString } = this.state;
    if (commentString) {
      this.setLoader(true);
      const { editorRef } = this.props;
      editorRef.removeMark('fakeSelection');

      const {
        comments: { activeCommentId, commentsData, commentSectionsCount },
        changeCommentCount,
        updateCommentData,
        saveDocument,
        userDocument: { documentId, userPreferences },
      } = this.props;
      const title = this.getTitle(userPreferences);
      const token = await getToken();
      const {
        status,
        data: { commentObject },
      } = await CommentsController.commentActions(
        {
          documentId,
          section: title,
          isExisting: commentSectionsCount.some(
            ({ section }) => section === title,
          ),
          commentData: {
            parentId: activeCommentId,
            comment: commentString,
            commentId:
              commentsData[activeCommentId].length > 0
                ? uuidv4()
                : activeCommentId,
          },
        },
        token,
        '/addComment',
      );
      if (status) {
        if (commentObject.commentId === commentObject.parentId) {
          const { editorRef: editor } = this.props;
          // todo: await is hack being used here to make sure savedocument waits for editor changes
          await this.toggleMark(commentObject, editor);
          saveDocument();
          changeCommentCount({ section: title, status: 'ADD' });
        }
        updateCommentData({
          ...commentObject,
        });
        this.updateState();
      } else {
        this.showDocumentDeleted();
      }
      this.setLoader(false);
    }
  };

  toggleMark = (commentObject, editor) => {
    editor.select(this.prevSelection).toggleMark({
      type: 'comment',
      data: {
        commentId: commentObject.commentId,
      },
    });
    return true;
  };

  deleteComment = async (commentData) => {
    const { index } = commentData;
    if (!index) {
      this.setState({ deleteThread: true, commentData });
      return;
    }
    this.deleteCommentThread(commentData);
  };

  deleteCommentThread = async (commentData) => {
    const { comment } = commentData;
    const isDelete = this.canBeDeleted(comment);
    const { comments } = this.state;
    if (isDelete) {
      const {
        userDocument: { documentId, userPreferences },
        changeCommentCount,
        deleteCommentData,
      } = this.props;
      const section = this.getTitle(userPreferences);
      if (comments.length) {
        const token = await getToken();
        const { status } = await CommentsController.commentActions(
          { ...commentData, documentId, section },
          token,
          '/deleteComment',
        );
        if (status) {
          if (commentData.index === 0) {
            changeCommentCount({ section, status: 'DELETE' });
            this.removeMarkAndUpdate(commentData);
          }
          deleteCommentData({ ...commentData });
          this.updateState();
        } else {
          this.showDocumentDeleted();
        }
      } else {
        this.removeMarkAndUpdate(commentData);
      }
    } else {
      this.setSnackBarState(
        true,
        'error',
        `You don't have access to delete comment...!`,
      );
    }
  };

  removeMarkAndUpdate = async (commentData) => {
    const { updateRemoveOnNextLoad, saveDocument } = this.props;
    await this.selectMark();
    updateRemoveOnNextLoad({
      commentId: commentData.commentId,
      type: 'push',
    });
    this.hidePopup();
    saveDocument();
  };

  selectMark = async () => {
    const {
      editorRef: editor,
      comments: { activeCommentId },
    } = this.props;
    const {
      value: { selection: prevSelection },
    } = editor;
    let con = true;
    let stepsAnchor = 0;
    let stepsFocus = 0;
    while (con) {
      editor.moveAnchorBackward(1);
      const {
        value: {
          selection: { isExpanded },
        },
      } = editor;
      if (!isExpanded) {
        con = false;
        break;
      }
      const { leaves } = JSON.parse(
        JSON.stringify(editor.value.fragment.getTexts()),
      )[0];
      // eslint-disable-next-line no-loop-func
      leaves.some((ele) => {
        if (ele.marks.length === 0) {
          con = false;
          return true;
        }
        return false;
      });
      if (!con) break;

      editor.moveFocusBackward(1);
      stepsAnchor += 1;
    }
    con = true;
    editor.select(prevSelection);
    while (con) {
      editor.moveFocusForward(1);
      const {
        value: {
          selection: { isExpanded },
        },
      } = editor;
      if (!isExpanded) {
        con = false;
        break;
      }
      const { leaves } = JSON.parse(
        JSON.stringify(editor.value.fragment.getTexts()),
      )[0];
      // eslint-disable-next-line no-loop-func
      leaves.some((ele) => {
        if (ele.marks.length === 0) {
          con = false;
          return true;
        }
        return false;
      });
      if (!con) break;

      editor.moveAnchorForward(1);
      stepsFocus += 1;
    }

    editor
      .select(prevSelection)
      .moveAnchorBackward(stepsAnchor)
      .moveFocusForward(stepsFocus);
    editor.removeMark({
      type: 'comment',
      data: {
        commentId: activeCommentId,
      },
    });
  };

  checkSubmitComment = async (event) => {
    const { commentString } = this.state;

    if (commentString.length > 300) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    if (event.key === 'Enter') {
      event.preventDefault();
      await this.addComment();
    }
  };

  makeActive = async (commentId) => {
    this.setState({
      getCommentLoad: true,
    });
    const {
      updatePopUpKeys,
      addComment,
      userDocument: { documentId, userPreferences },
      comments: { commentsData, commentCard },
    } = this.props;
    const section = this.getTitle(userPreferences);
    if (!commentsData[commentId])
      await this.getCommentData(commentId, documentId, section, addComment);
    updatePopUpKeys({
      activeCommentId: commentId,
      commentCard: {
        ...commentCard,
        status: true,
      },
      isContextMenu: {},
    });
    this.setState({
      getCommentLoad: false,
    });
  };

  getCommentData = async (commentId, documentId, section, addComment) => {
    const token = await getToken();
    const { status, data } = await CommentsController.commentActions(
      { commentId, documentId, section },
      token,
      '/getComment',
    );
    if (status) {
      addComment({
        commentId: Object.keys(data)[0],
        data: data[commentId],
      });
    }
  };

  hidePopup = () => {
    const { editorRef } = this.props;
    const { updatePopUpKeys } = this.props;
    updatePopUpKeys({
      currentCommentIds: [],
      top: 0,
      left: 0,
      commentCard: {},
      isContextMenu: {},
      activeCommentId: '',
    });
    setTimeout(() => {
      editorRef.withoutSaving(() => editorRef.removeMark('fakeSelection'));
    }, 0);
    editorRef.withoutSaving(() => editorRef.removeMark('fakeSelection'));
  };

  handleCloseSnackBar = () => {
    this.setState({ showSnackBar: false });
  };

  setSnackBarState = (showSnackBar, snackBarType, snackBarMessage) => {
    this.setState({ showSnackBar, snackBarMessage, snackBarType });
  };

  canBeDeleted = (comment) => {
    if (!comment) return true;
    const {
      permission,
      userData: {
        profile: { sub: currentUser },
      },
      userDocument: { userId: docOwner },
    } = this.props;
    if (permission === AccessTypes.OWNER) return true;
    if (permission === AccessTypes.CO_OWNER) {
      if (comment.userId === docOwner) return false;
      return true;
    }
    return comment.userId === currentUser;
  };

  onFocus = () => {
    this.activeElement = document.activeElement;
    const { editorRef } = this.props;
    editorRef.withoutSaving(() => editorRef.addMark({ type: 'fakeSelection' }));
  };

  onBlur = () => {
    const { editorRef } = this.props;
    editorRef.withoutSaving(() =>
      editorRef.removeMark({ type: 'fakeSelection' }),
    );
  };

  onChange = (event) => {
    this.activeElement = document.activeElement;
    this.setState({ commentString: event.currentTarget.textContent });
  };

  onPaste = (event) => {
    this.activeElement = document.activeElement;
    const text = (event.originalEvent || event).clipboardData.getData(
      'text/plain',
    );
    if (text) {
      event.preventDefault();
      document.execCommand('insertHTML', false, text);
    }
  };

  cancelThread = () => {
    this.setState({
      deleteThread: false,
      commentData: {},
    });
  };

  deleteThread = () => {
    const { commentData } = this.state;
    this.deleteCommentThread(commentData);
  };

  render() {
    const {
      comments: {
        commentCard,
        isContextMenu,
        currentCommentIds,
        loading: commentsLoading,
      },
      userData,
      editorRef,
    } = this.props;
    let currentUser;
    if (userData) {
      const { profile } = userData;
      if (profile) {
        const { sub } = profile;
        currentUser = sub;
      }
    }
    let { focusBlock } = this.props;
    if (editorRef && editorRef.value) {
      const {
        value: { focusBlock: updatedFocusBlock },
      } = editorRef;
      focusBlock = updatedFocusBlock;
    }
    const {
      top,
      left,
      right,
      commentString,
      comments,
      loading,
      getCommentLoad,
      showSnackBar,
      snackBarMessage,
      snackBarType,
      deleteThread,
    } = this.state;

    return (
      <>
        {window.env !== 'test' && (
          <SnackBarAlerts
            showSnackBar={showSnackBar}
            handleClose={this.handleCloseSnackBar}
            snackBarMessage={snackBarMessage}
            snackBarType={snackBarType}
          />
        )}
        {(this.activeElement || focusBlock) &&
        (commentCard.status || isContextMenu.status) ? (
          <CommentPopup
            right={right}
            top={top}
            left={left}
            ref={this.popupRef}
            isContextMenu={isContextMenu.status}
            data-testid="commentPopUpWrapper"
            id="commentPopUpWrapper"
          >
            {deleteThread && (
              <Overlay data-testid="deleteOverlay">
                <ThreadDeleteMsg>Delete this comment thread?</ThreadDeleteMsg>
                <ThreadDeleteButtons>
                  <ThreadButton onClick={this.cancelThread}>
                    Cancel
                  </ThreadButton>
                  <ThreadButton onClick={this.deleteThread}>
                    Delete
                  </ThreadButton>
                </ThreadDeleteButtons>
              </Overlay>
            )}
            <CommentNumbers
              isContextMenu={isContextMenu.status}
              data-testid="commentPopUpNumbersWrapper"
            >
              {currentCommentIds.map((ele, index) => (
                <>
                  <ShowComments
                    restrictCursor={getCommentLoad}
                    key={ele}
                    onMouseDown={() =>
                      !getCommentLoad ? this.makeActive(ele) : {}
                    }
                    data-testid={`showCommentsWrapper_${index}`}
                  >
                    <CommentIndex data-testid="commentIndex">
                      Review {index + 1}
                    </CommentIndex>
                    <Arrow data-testid="commentArrow">
                      <RightArrowSVG width="20px" height="20px" />
                    </Arrow>
                  </ShowComments>
                </>
              ))}
            </CommentNumbers>
            <CommentsData commentCard={commentCard.status}>
              {commentsLoading ? (
                <Spinner>
                  <FontAwesome name="spinner" size="lg" spin />
                </Spinner>
              ) : (
                <>
                  <Comments
                    ref={this.commentsRef}
                    data-testid="commentsListWrapper"
                  >
                    {comments &&
                      comments.map((ele, index) => (
                        <UserProfileWrapper
                          key={`${ele.name}_${ele.creationTime}`}
                          data-testid={`userProfileWrapper_${index}`}
                        >
                          <User
                            data-testid={`userWrapper_${index}`}
                            currUser={ele.userId === currentUser}
                          >
                            <UserProfile data-testid={`userProfile_${index}`}>
                              <UserName
                                title={`${ele.name} ${ele.familyName}`}
                                data-testid={`userName_${index}`}
                              >
                                {ele.name} {ele.familyName}
                              </UserName>
                              <DeleteIconWrapper
                                data-testid={`deleteIconWrapper_${index}`}
                                onMouseDown={() =>
                                  this.deleteComment({
                                    commentId: ele.commentId,
                                    parentId: ele.parentId,
                                    index,
                                    comment: ele,
                                  })
                                }
                              >
                                <DeleteIcon
                                  color={
                                    !this.canBeDeleted(ele)
                                      ? 'lightgray'
                                      : DeleteColor
                                  }
                                  width="16px"
                                  height="16px"
                                />
                              </DeleteIconWrapper>
                            </UserProfile>
                          </User>
                          <DeleteMessageWrapper
                            data-testid={`deleteMessageWrapper_${index}`}
                            currUser={ele.userId === currentUser}
                          >
                            <Message
                              data-testid={`messageWrapper_${index}`}
                              currUser={ele.userId === currentUser}
                            >
                              <MessageText data-testid={`messageText_${index}`}>
                                {ele.comment}
                              </MessageText>
                              <TimeWrapper data-testid={`timeWrapper_${index}`}>
                                {moment(ele.creationTime).fromNow()}
                              </TimeWrapper>
                            </Message>
                          </DeleteMessageWrapper>
                        </UserProfileWrapper>
                      ))}
                  </Comments>
                </>
              )}
              <SendMessageWrapper>
                <MessageWrapper data-testid="sendMessageWrapper">
                  {!commentString.length && (
                    <PlaceHolder>{PLACE_HOLDER}</PlaceHolder>
                  )}
                  <TextArea
                    contentEditable
                    ref={this.textAreaRef}
                    data-testid="textAreaWrapper"
                    onKeyDown={this.checkSubmitComment}
                    onFocus={this.onFocus}
                    onInput={this.onChange}
                    onPaste={this.onPaste}
                    onBlur={this.onBlur}
                    html={commentString}
                  />
                </MessageWrapper>
                <Buttons>
                  <CancelBtn
                    onMouseDown={this.hidePopup}
                    id="commentPopUpCancelButton"
                  >
                    {CANCEL}
                  </CancelBtn>
                  <Send onMouseDown={this.addComment} data-testid="sendWrapper">
                    {loading && <FontAwesome name="spinner" size="lg" spin />}
                    <MsgBtn loading={loading} commentString={commentString}>
                      {COMMENT}
                    </MsgBtn>
                  </Send>
                </Buttons>
              </SendMessageWrapper>
            </CommentsData>
          </CommentPopup>
        ) : null}
      </>
    );
  }
}

CommentsCard.propTypes = {
  comments: propTypes.shape({
    top: propTypes.number.isRequired,
    left: propTypes.number.isRequired,
    isContextMenu: propTypes.object.isRequired,
    currentCommentIds: propTypes.arrayOf(
      propTypes.oneOfType([propTypes.object, propTypes.string]),
    ),
    activeCommentId: propTypes.string.isRequired,
    commentsData: propTypes.object.isRequired,
    loading: propTypes.bool.isRequired,
  }).isRequired,
  editorRef: propTypes.objectOf(propTypes.object).isRequired,
  saveDocument: propTypes.func.isRequired,
  permission: propTypes.string.isRequired,
  userData: propTypes.shape({
    profile: propTypes.object.isRequired,
  }).isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  updatePopUpKeys: (params) => {
    dispatch(Actions.commentActions.updatePopUpKeys(params));
  },
  updateCommentData: (params) => {
    dispatch(Actions.commentActions.updateCommentData(params));
  },
  deleteCommentData: (params) => {
    dispatch(Actions.commentActions.deleteComment(params));
  },
  changeCommentCount: (params) => {
    dispatch(Actions.commentActions.changeCommentCount(params));
  },
  addComment: (params) => {
    dispatch(Actions.commentActions.addComment(params));
  },
  updateRemoveOnNextLoad: (params) => {
    dispatch(Actions.editResumeFormActions.updateRemoveOnNextLoad(params));
  },
});

const mapStateToProps = (state, ownProps) => {
  const { formatType } = ownProps;
  const common = {
    comments: state.commentsReducer,
    userData: state.user,
  };
  if (formatType === FormatTypes.RESUME) {
    return {
      userDocument: state.editResumeFormReducer,
      ...common,
    };
  }

  if (formatType === FormatTypes.COVER_LETTER) {
    return {
      userDocument: state.editCoverLetterFormReducer,
      ...common,
    };
  }

  return null;
};

export default connect(mapStateToProps, mapDispatchToProps)(CommentsCard);
